import { render, staticRenderFns } from "./DashboardPageGrid.vue?vue&type=template&id=2f5f3802&scoped=true&"
import script from "./DashboardPageGrid.vue?vue&type=script&lang=js&"
export * from "./DashboardPageGrid.vue?vue&type=script&lang=js&"
import style0 from "./DashboardPageGrid.vue?vue&type=style&index=0&id=2f5f3802&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5f3802",
  null
  
)

export default component.exports